module.exports = __webpack_public_path__ + "img/info.2a305042.png";